<template>
  <modal-base
    :title="title"
    :description="message"
    :svg-colour="warning ? 'text-red-600' : 'text-green-500'"
    :bgcolor="warning ? 'bg-red-100' : 'bg-gray-100'"
    max-width="max-w-lg"
  >
    <template #svg>
      <slot name="svg" />

      <svg
        v-if="!warning && !$slots.svg"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        data-prefix="fad"
        data-icon="check"
        role="img"
        viewBox="0 0 512 512"
      >
        <g class="fa-group">
          <path
            class="fa-secondary"
            fill="currentColor"
            d="M504.5 144.42L264.75 385.5 192 312.59l240.11-241a25.49 25.49 0 0 1 36.06-.14l.14.14L504.5 108a25.86 25.86 0 0 1 0 36.42z"
            opacity="0.4"
          />
          <path
            class="fa-primary"
            fill="currentColor"
            d="M264.67 385.59l-54.57 54.87a25.5 25.5 0 0 1-36.06.14l-.14-.14L7.5 273.1a25.84 25.84 0 0 1 0-36.41l36.2-36.41a25.49 25.49 0 0 1 36-.17l.16.17z"
          />
        </g>
      </svg>
      <svg
        v-if="warning && !$slots.svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      ><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" /></svg>
    </template>
    <template #content>
      <slot name="content" />
    </template>
    <template #primaryButton>
      <PrimaryButton
        :class="{ ' border-red-700 bg-red-700 hover:bg-red-600': warning }"
        :text="primaryText"
        :loading="loading"
        :disabled="primaryDisabled"
        @click="primary()"
      />
    </template>
    <template #secondaryButton>
      <SecondaryButton
        :class="{ 'opacity-0': primaryOnly }"
        :text="secondaryText"
        @click="secondary()"
      />
    </template>
  </modal-base>
</template>

<script>
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import SecondaryButton from '@/app/shared/components/base/button/secondaryButton.vue';
import ModalBase from '@/app/shared/components/base/modal/modalBase.vue';

export default {
  components: {
    PrimaryButton,
    SecondaryButton,
    ModalBase,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    primaryText: {
      type: String,
      default: 'Confirm',
    },
    secondaryText: {
      type: String,
      default: 'Cancel',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    primaryOnly: {
      type: Boolean,
      default: false,
    },
    primaryDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    primary() {
      this.$emit('primary');
    },

    secondary() {
      if (!this.primaryOnly) this.$emit('secondary');
    },
  },
};
</script>
